<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-8 col-6">
                    <h2>Schedulers</h2>
                    </div>
                    
                </div>
                
            </div>
            </div>
        </div>
        <div>
            <div class="container-fluid mt--6 filter-show">
                <div class="card w-100 p-2 mb-2  d-inline-block">
                    <div class="d-flex justify-content-between">
                    <h5 class="ml-3">Filters</h5>
                    <span class="btn btn-link" @click="showFilters = !showFilters">
                        <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
                    </span>
                    </div>
                    <div class="row" v-if="showFilters">
                    <div class="col-lg-12">
                        <form class="row">
                        <div class="col-md-6 col-lg-2">
                            <label for="filter" class="">From</label>
                            <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                        </div>
                        <div class="col-md-6 col-lg-2">
                            <label for="filter" class="">To</label>
                            <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                        </div>
                        <div class="col-md-6 col-lg-2">
                            <!-- <button @click="clearSearch()" type="button" class="btn btn-secondary rounded mt-4">Clear</button> -->
                            <button @click="searchLog()" type="button" class="btn btn-primary rounded mt-4">Filter</button>
                        </div>
                        </form>
                    </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid" >
                <div class="row">
                    <div class="col-xl-12">
                        <div class="card vh-75" id="scroll">
                            <div class="table-responsive">
                            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                            <table class="table invt align-items-center table-flush table-hover bidtbl bid-acc">
                                <thead class="thead-light psticky">
                                <tr>

                                <th   
                                        scope="col" 
                                        class="sort text-left"
                                        >Date</th>
                                        <th 
                                        
                                        scope="col" 
                                        class="sort text-left"
                                        >Name</th>
                                        <th 
                                        
                                        scope="col" 
                                        class="sort text-center"
                                        >Status</th>    
                                </tr>
                                </thead>
                                <tbody class="list">
                                <tr v-if="logs.length == 0 && !loading">
                                    <td><p class="nodata">No data available</p>
                                </td>
                                </tr>
                                <tr v-for="data in logs" :key="data.id">
                                    <td class="text-left">{{moment(data.date).format("MM/DD/YYYY, h:mm:ss a") }}</td>
                                    <td class="text-uppercase text-left">{{data.cronName}}</td>
                                    <td class="text-center">
                                        <span v-if="data.status == 'COMPLETED'" class="text-success">{{data.status}}</span>
                                        <span v-if="data.status != 'COMPLETED'"  class="text-danger">{{data.status}}</span>

                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example" v-if="!(logs.length == 0 && currentPage === 0)">
                                <ul class="pagination justify-content-center">
                                    <li class="page-item" v-bind:class="{ disabled: currentPage === 0 }">
                                        <a class="page-link cursor-pointer"   @click="previous()">
                                            <i class="fa fa-angle-left"></i>
                                            <span class="sr-only">Previous</span>
                                        </a>
                                    </li>
                                    <li class="page-item active"><a class="page-link">{{currentPage+1}}</a></li>
                                    <li class="page-item" v-bind:class="{ disabled: this.logs.length < this.perPage }"  >
                                        <a class="page-link cursor-pointer" @click="next()">
                                            <i class="fa fa-angle-right"></i>
                                            <span class="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        loading : false,
        currentPage: 0,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "",
        sortOrder: "ASC",
        logs : [],
        prevStatus : null,
        newStatus : null,
        isBrokerDealer : false,
        tenantName : "",
        branchList : [],
        selectedBranch : "",
        selectedBrokerDealer : "",
        selectedOrgToken : null,
        fromDate : "",
        toDate : "",
        showFilters : false,

    };
  },
  methods: {

    clearFilter(){
        this.prevStatus  = null;
        this.newStatus  = null;
        this.filterUser = null;
        this.isNoUserLog = false;
        this.filelogs();
    },
    searchLog(){
        this.currentPage = 0;
        this.filelogs();  
    },
    
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 0;
        this.filelogs();  
    },
    next(){
        if(this.logs.length === this.perPage){
            this.currentPage++;
            this.filelogs(); 
        }
        
    },
    previous(){
        if(this.currentPage > 0){
            this.currentPage--;
            this.filelogs(); 
        }
        
    },
    changeBranch(name){
        this.selectedOrgToken = this.branchList.find((branch) => branch.name == name ).orgToken;
        this.filelogs()
    },
    filelogs(){
      this.loading = true;
      const auth = {
       
      };
      var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
      var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
      this.$http
        .get(
          config.baseUrlAutoBidder + "/logs/scheduler-status"+
          "?offset="+this.currentPage+
          "&limit="+this.perPage+
          "&searchText="+this.searchValue+
          "&fromDate="+
           fDate+
           "&toDate="+
           tDate,
          auth
        )
        .then((result) => {
            this.logs = result.data;
            this.loading = false;

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getOrganisationList() {
      const auth = {
      };
      this.$http
        .get(config.baseUrlBidSide + "/organization/list?status=ACTIVE&type=BRANCH&orgToken="+authService.getOrgToken(), auth)
        .then((response) => {
          if(response.data && response.data.length){
            this.branchList = response.data;
            this.selectedBranch = response.data[0].name;
            this.selectedOrgToken = response.data[0].orgToken;
            this.filelogs();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    setComplianceNotificationCount(){
         const auth = {
         headers: {'org-token' : authService.getOrgToken()  }
         };
         this.$http
         .post(
            config.baseUrlAutoBidder +
               "/autobidder/notification-count-decrement?cognitoSub="+
               authService.getUser().cognitoSub,
               auth

         )
         .then(result => {
            this.$root.$emit("compliancenotificationreset"); 
            console.log(result)
         })
      },
   
  },
  mounted() {
    this.fromDate = this.moment().format("MM-DD-YYYY");
    this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
        console.log("accessToken is not found", err);
        } else {
            this.tenantName = role[0].split("-")[0];
            window.location.pathname.includes('brockerdealer') ? this.isBrokerDealer = true : this.isBrokerDealer = false;
            this.selectedBranch = this.tenantName.toLocaleLowerCase();
            this.selectedOrgToken = authService.getOrgToken();
            this.selectedBrokerDealer = "newedge";
            this.filelogs();
            this.setComplianceNotificationCount();
        
        }
    });
  }
};
</script>